module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s414x232-650150775cab3bf8eb2764ccf99325e6.png";